import { ActionTypes } from "@/App/constants/actionTypes";
import { MembersTypes } from "@/types";

type UserSearchForMembersAction = {
  type: typeof ActionTypes.SEARCH_FOR_MEMBER;
  payload: MembersTypes.MemberSearchOptions;
  formName: string;
};

export const userSearchForMembers = (data: { data: MembersTypes.MemberSearchOptions; formName: string }): UserSearchForMembersAction => {
  return {
    type: ActionTypes.SEARCH_FOR_MEMBER,
    payload: data.data,
    formName: data.formName,
  };
};

type UserSearchForMembersResultsAction = {
  type: typeof ActionTypes.SEARCH_FOR_MEMBER_RESULTS;
  payload: MembersTypes.MemberSearchResponse;
};

export const userSearchForMembersResults = (data: MembersTypes.MemberSearchResponse): UserSearchForMembersResultsAction => {
  return {
    type: ActionTypes.SEARCH_FOR_MEMBER_RESULTS,
    payload: data,
  };
};

export type MemberSearchAction = UserSearchForMembersAction | UserSearchForMembersResultsAction;
